import React from "react";
import { Link } from "react-router-dom";
import { MdPlayArrow, MdOutlineEmail, MdLocationOn } from "react-icons/md";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaPhone,
  FaApple,
  FaGooglePlay,
} from "react-icons/fa";
import logo from "../../../images/logo.png";
import "./Footer.css";

const Footer = () => {
  const decor = {
    textDecoration: "none",
  };

  return (
    <div className="trry">
      <div className="general-footer">
        <div className="footer-container">
          <div className="footer-wrapper">
            <img className="footer-logo logo-img" src={logo} alt="" />
            <p>
              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Impedit
              tenetur quia ullam quos nihil nobis hic iste libero aliquam
              architecto.
            </p>
            <h5>
              Monday - Friday: <span>8am - 6pm</span>
            </h5>
            <h5>
              Saturday - Sunday: <span>9am - 3pm</span>
            </h5>
          </div>
          <div className="footer-wrapper">
            <h2>Helpful links</h2>
            <div className="footer-links">
              <MdPlayArrow className="arrow-icon" />
              <Link style={decor} to="/" className="foot">
                <li>About Our Company</li>
              </Link>
            </div>
            <div className="footer-links">
              <MdPlayArrow className="arrow-icon" />
              <Link style={decor} to="/" className="foot">
                <li>Our last news</li>
              </Link>
            </div>
            <div className="footer-links">
              <MdPlayArrow className="arrow-icon" />
              <Link style={decor} to="/" className="foot">
                <li>Pricing Plans</li>
              </Link>
            </div>
            <div className="footer-links">
              <MdPlayArrow className="arrow-icon" />
              <Link style={decor} to="/" className="foot">
                <li>Contacts</li>
              </Link>
            </div>
            <div className="footer-links">
              <MdPlayArrow className="arrow-icon" />
              <Link style={decor} to="/" className="foot">
                <li>Help Center</li>
              </Link>
            </div>
          </div>
          <div className="footer-wrapper">
            <h2>Contact Info</h2>
            <div className="footer-links">
              <MdOutlineEmail className="arrow-icon" />:
              <Link style={decor} to="/" className="foot">
                <li>yourmail@domain.com</li>
              </Link>
            </div>
            <div className="footer-links">
              <MdLocationOn className="arrow-icon" />:
              <Link style={decor} to="/" className="foot">
                <li>USA 27TH Brooklyn NY</li>
              </Link>
            </div>
            <div className="footer-links">
              <FaPhone className="arrow-icon" />:
              <Link style={decor} to="/" className="foot">
                <li>+7(111)123456789</li>
              </Link>
            </div>
            <div className="footer-mini-icon">
              <FaFacebookF className="mini-icon" />
              <FaTwitter className="mini-icon" />
              <FaInstagram className="mini-icon" />
            </div>
          </div>
          <div className="footer-wrapper">
            <h2>Download our API</h2>
            <p>
              Start working with Homeradar that can provide everything you need
            </p>
            <div className="app">
              <Link style={decor} to="/" className="app-icon">
                <span>
                  <FaApple />
                </span>
                <li>App Store</li>
              </Link>
            </div>
            <div className="app">
              <Link style={decor} to="/" className="app-icon">
                <span>
                  <FaGooglePlay />
                </span>
                <li>Play Market</li>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
